import moment from "moment";

export const numberToCurrency = (
  number: number,
  showPrefix: boolean = true
): string => {
  const currency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number / 100);

  if (showPrefix) {
    return currency;
  } else {
    return currency.replace("R$", "").trim();
  }
};

export const formatDate = (date: string): string => {
  return date && moment(date).format("L");
};
